import { gql } from '@apollo/client';
import { SearchImageSourceCategoriesQuery } from '__generated__/queries-web';
import { client } from 'apollo';

export const SEARCH_IMAGE_SOURCES_CATEGORIES = gql`
  query SearchImageSourceCategories(
    $where: ImageSourceCategoryFilterInput
    $sourceWhere: ImageSourceFilterInput
  ) {
    imageSourceCategories(first: 100, orderBy: title_ASC, where: $where) {
      id
      title
      sources(first: 100, orderBy: title_ASC, where: $sourceWhere) {
        id
        title
      }
    }
  }
`;

export const searchImageSourceCategories = async (search: string) => {
  // can't use hook, used outside components
  const { data } = await client.query<SearchImageSourceCategoriesQuery>({
    query: SEARCH_IMAGE_SOURCES_CATEGORIES,
    variables: {
      where: {
        imageSources_some: {
          title_contains: search || undefined,
        },
      },
      sourceWhere: {
        title_contains: search || undefined,
      },
    },
  });
  return data?.imageSourceCategories;
};
